var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 3C16.9337 3 18.5007 4.567 18.5007 6.5C18.5007 8.433 16.9337 10 15.0007 10M18.0007 13.5088C20.0786 14.2448 21.7227 15.7225 22.5041 17.5667C23.0428 18.838 21.8814 20 20.5007 20M9.00071 10C7.06771 10 5.50071 8.433 5.50071 6.5C5.50071 4.567 7.06771 3 9.00071 3C10.9337 3 12.5007 4.567 12.5007 6.5C12.5007 8.433 10.9337 10 9.00071 10ZM1.70998 17.1143C2.96635 14.6879 5.75826 13 9.00071 13C12.2431 13 15.035 14.6879 16.2914 17.1143C17.0532 18.5856 15.6575 20 14.0007 20H4.00071C2.34385 20 0.948139 18.5856 1.70998 17.1143Z",
    stroke: "#171717",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentsIcon);
export default __webpack_public_path__ + "static/media/departments-icon.e103d5577f4ffc2deefe7101b585db4f.svg";
export { ForwardRef as ReactComponent };